import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { exportFileJackpotHistory, jackpotHistoryListApi } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import moment from "moment";
import JackpotHistoryModal from "components/Modals/JackpotHistory/JackpotHistoryModal";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import PermissionGate from "components/PermissionGate";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
  {
    name: "datepicker",
    type: "datepicker",
    label: "",
    placeholder: "",
  },
];
const initialValuesForFilter = {
  search: "",
};

const List = () => {
  const dispatch = useDispatch();
  const { jackpotHistoryList, loading, totalJackpotHistory } = useSelector(
    ({ Jackpot }) => Jackpot,
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [showPicker, setShowPicker] = useState(false);
  const [jackpotModalShow, setJackpotModalShow] = useState(false);
  const [id, setId] = useState(null);
  const todayDate = moment().format("YYYY-MM-DD");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "All",
    startDate: todayDate,
    endDate: todayDate,
  });

  useEffect(() => {
    getApiData(filter);
    setcolumns(Columns({ handleEditHandler }));
  }, [filter]);

  async function getApiData(query) {
    try {
      dispatch(jackpotHistoryListApi({ data: query }));
    } catch (error) { }
  }

  const handleEditHandler = (info) => {
    setJackpotModalShow(true);
    setId(info?._id);
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
    });
  };

  // const onClickExport = () => {
  //   dispatch(exportGameList({
  //     data: {
  //       startDate: filter.startDate, endDate: filter.endDate
  //     }
  //   }));
  // };
  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setFilter((prevFilter) => ({
      ...prevFilter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setShowPicker(false);
  };

  const handleExport = (type) => {
    const body = {
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      startDate: filter.startDate,
      endDate: filter.endDate,
      search: filter.search,
      downloadType: type,
    };

    const callback = (err, res) => {
      if (err) {
        toast.error(err?.message || "something went wrong");
      } else {
        toast.success(res?.message || "file exported successfully!");
      }
    };
    dispatch(exportFileJackpotHistory({ data: body, callback }));
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {jackpotModalShow && (
        <JackpotHistoryModal
          show={jackpotModalShow}
          handleClose={() => {
            setJackpotModalShow(false);
            setId(null);
          }}
          title={"Jackpot Details"}
          id={id}
        />
      )}
      <section className="section">
        <div className="section-header">
          <h1>Jackpot History</h1>

          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">Game History</div>
          </div> */}
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">History</h2>
                </div>
              </div>
              <PermissionGate permission="exports_jackpot_history">
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    {/* <button
                    className="btn btn-primary"
                    onClick={() => onClickExport()}
                  >
                    Export
                  </button> */}
                    <Dropdown>
                      <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        Export
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleExport("csv")}>
                          CSV
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleExport("xlsx")}>
                          Xlsx
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </PermissionGate>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                    dateRange={filter}
                    showPicker={showPicker}
                    setShowPicker={setShowPicker}
                    handleSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          {jackpotHistoryList?.length > 0 && (
            <Table
              data={jackpotHistoryList}
              columns={columns}
              setFilter={setFilter}
              total={totalJackpotHistory}
              filter={filter}
            />
          )}
          {!loading && jackpotHistoryList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Record Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
